import { IErvkCheckList } from 'APIPackage/DictionariesModule/interfaces/IErvkCheckList';

import { makeCreateErvkCheckListSelectOption } from './makeCreateErvkCheckListSelectOption';

export const createErvkChecklistSelectOption = makeCreateErvkCheckListSelectOption<IErvkCheckList>(
  'id',
  'number',
  'description',
);
